import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=4f3220b8&"
import script from "./ContactBox.vue?vue&type=script&lang=js&"
export * from "./ContactBox.vue?vue&type=script&lang=js&"
import style0 from "./ContactBox.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports